import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Star, Menu, X } from 'lucide-react';
import { cn } from '../lib/utils';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  const navBackground = useTransform(scrollY, [0, 50], ['rgba(10, 14, 39, 0)', 'rgba(10, 14, 39, 0.8)']);
  const navBackdrop = useTransform(scrollY, [0, 50], ['blur(0px)', 'blur(12px)']);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'Problems',
    href: '#problems'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Team',
    href: '#team'
  }];
  return <motion.nav style={{
    backgroundColor: navBackground,
    backdropFilter: navBackdrop
  }} className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-transparent', isScrolled && 'border-slate-800/50')} data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex items-center justify-between h-20" data-id="element-102">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-103">
            <Star className="h-6 w-6 text-cyan-400 fill-cyan-400/20" data-id="element-104" />
            <span className="font-heading text-2xl font-bold text-white tracking-wide" data-id="element-105">
              Starkeep
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:block" data-id="element-106">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-107">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-slate-300 hover:text-cyan-400 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 relative group" data-id="element-108">
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 transition-all duration-300 group-hover:w-full" data-id="element-109" />
                </a>)}
              <a href="#contact" className="bg-cyan-500/10 hover:bg-cyan-500/20 text-cyan-400 border border-cyan-500/50 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:shadow-[0_0_15px_rgba(6,182,212,0.3)]" data-id="element-110">
                Contact Us
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-111">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-300 hover:text-white p-2" data-id="element-112">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-113" /> : <Menu className="h-6 w-6" data-id="element-114" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden bg-[#0a0e27]/95 backdrop-blur-xl border-b border-slate-800" data-id="element-115">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-116">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-slate-300 hover:text-cyan-400 block px-3 py-2 rounded-md text-base font-medium" data-id="element-117">
                {link.name}
              </a>)}
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="text-cyan-400 block px-3 py-2 rounded-md text-base font-medium" data-id="element-118">
              Contact Us
            </a>
          </div>
        </motion.div>}
    </motion.nav>;
}